module.exports = __webpack_public_path__ + "static/media/banner-shopping@3x.264794c7.png";